import httpClient from './httpClient';

export const CLEAR_SEARCH_RESULT_CACHE_ENDPOINT = '/backoffice/clear-search-result-cache';
export const clearSearchResultCache = async () => httpClient.post(`${CLEAR_SEARCH_RESULT_CACHE_ENDPOINT}`);
